export default "__VITE_ASSET__BrXJ3YXK__"